import useDynamicPage from "@/hooks/useDynamicPage";
import { DynamicPageSeo } from "@/ui/DynamicPageSeo";
import { ContentBlocks } from "@/ui/ContentBlocks";

export default function Home({ prefix, title, seo, canonical, data }) {
  return (
    <>
      <DynamicPageSeo
        title={seo?.title || title}
        description={seo?.description || ""}
        canonical={seo?.canonical || canonical}
        keywords={seo?.keywords || ""}
        robots={seo?.robots || ""}
        json_schema={seo?.json_schema || ""}
      />
      <ContentBlocks data={data} prefix={prefix} />
    </>
  );
}

export async function getStaticProps() {
  const url_slug = "/";
  const page = useDynamicPage(url_slug);

  return {
    props: {
      isBuilder: true,
      prefix: `page_homepage`,
      title: page?.title || "",
      seo: page?.seo || {},
      canonical: `/`,
      data: page?.content || [],
    },
  };
}
